<template>
  <el-row v-if="activeFlow" style="margin-bottom: 0" :gutter="20">
    <el-col :xs="24" :md="8" :lg="6">
      <el-card v-if="activeFlow.sections.length === 0" class="flow-editor-list flow-editor-panel">
        <h1>No screens created yet.</h1>
      </el-card>
      <el-card v-else class="flow-editor-list flow-editor-panel">
        <div
          @click.prevent="onTabChanged({ name: 'config-default' })"
          :class="{ 'is-current': currentTab === 'section-config-default' }"
          class="flow-editor-list-item"
        >
          CONFIG - General
        </div>

        <div
          class="flow-editor-list-item"
          v-for="(section, index) in activeFlow.sections"
          v-dragging="{
            item: section,
            list: activeFlow.sections,
            group: 'flow_sections',
          }"
          :class="{
            'is-current': currentTab === `section-${section.sectionId}`,
          }"
          :key="`${activeFlow.id}-section-${index}`"
          @click.prevent="onTabChanged({ name: section.sectionId })"
        >
          {{ section.title }}
        </div>

        <div
          @click.prevent="onTabChanged({ name: 'config-end-flow' })"
          :class="{ 'is-current': currentTab === 'section-config-end-flow' }"
          class="flow-editor-list-item"
        >
          CONFIG - End Flow
        </div>
      </el-card>
    </el-col>
    <el-col :xs="24" :md="16" :lg="18">
      <el-card class="flow-editor-view flow-editor-panel">
        <template v-if="currentTab === 'section-config-default'">
          <ConfigDefault
            :allFlowsNameArray="allFlowsNameArray"
            :resetOptions="resetOptions"
            :resetDescription="resetDescription"
            :cancelOptions="cancelOptions"
            :active-flow="activeFlow"
          />
        </template>
        <template v-else-if="currentTab === 'section-config-end-flow'">
          <ConfigEndFlow :active-flow="activeFlow" />
        </template>
        <template v-else>
          <div
            v-for="(section, index) in activeFlow.sections"
            :key="`${activeFlow.id}-section-${index}`"
          >
            <template v-if="currentTab === `section-${section.sectionId}`">
              <el-row type="flex" :gutter="0" justify="space-between" class="flow-section-title">
                <el-input v-model="section.title">
                  <div slot="prepend">Section Title</div>
                  <div slot="append" style="cursor: pointer">
                    <i v-copy="{ text: section.title }" class="el-icon-document-copy"></i>
                  </div>
                </el-input>
              </el-row>
              <el-row>
                <el-button
                  plain
                  size="mini"
                  type="warning"
                  icon="el-icon-delete"
                  @click.prevent="onDeleteSection(index)"
                >
                  Delete Screen
                </el-button>
              </el-row>
              <el-row>
                <h1>Select form for WhatsApp Flow Screen</h1>
                <el-select @focus="fetchForms" @change="autoName($event, section)" v-model="section.formId" placeholder="Select form below">
                  <el-option v-for="(form, index) in formOptions" :key="`form-${index}`" :label="form.label" :value="form.value"></el-option>
                </el-select>
                <el-button
                  v-if="!section.formId"
                  type="text"
                  @click="$router.push('/editor/form')"
                  style="margin-left: 10px;"
                  icon="el-icon-plus"
                >
                  Create new form
                </el-button>
                <el-button
                  v-else
                  type="text"
                  @click="$router.push('/editor/form')"
                  style="margin-left: 10px;"
                  icon="el-icon-top-right"
                >
                  View details
                </el-button>
              </el-row>
            </template>
          </div>
        </template>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { rest } from "@/store/api";
import ConfigDefault from "./ConfigDefault";
import ConfigEndFlow from "../View/ConfigEndFlow";

export default {
  data() {
    return {
      currentTab: null,
      formOptions: [],
      loading: false,
    };
  },
  components: {
    ConfigDefault,
    ConfigEndFlow,
  },
  props: [
    "activeFlow",
    "allFlowsNameArray",
    "cancelOptions",
    "resetDescription",
    "resetOptions",
    "arrayFlows",
  ],
  mounted() {
    this.currentTab = "section-config-default";

    this.$eventBus.$on("setSelectedSection", (sectionId) => {
      this.currentTab = sectionId;
    });
  },
  computed: {
    flowOptions() {
      return this.arrayFlows.map((flow) => {
        return {
          label: `flow - ${flow.title.toLowerCase()}`,
          value: flow.flowId,
          children: [
            ...flow.sections.map((section) => {
              return {
                label: `section - ${section.title.toLowerCase()}`,
                value: section.sectionId,
                disabled: _.includes(this.currentTab, section.sectionId),
              };
            }),
          ],
        };
      });
    },
  },
  methods: {
    autoName(formId, section) {
      const form = this.formOptions.find((form) => form.value === formId);
      section.title = form.label;
    }, 
    async fetchForms() {
      try {
        this.loading = true;
        const response = await rest("get", "forms/v1");
        if (response.data) {
          const forms = response.data;
          this.formOptions = forms.map((form) => {
            return {
              label: form.name,
              value: form.id,
            };
          });
        }
      } catch (err) {
        this.formOptions = [];
        this.$message({
          type: "error",
          message: "Failed to fetch the form list, please refresh the page.",
        });
      } finally {
        this.loading = false;
      }
    },
    onTabChanged(event) {
      let sectionId = null;
      if (_.includes(event.name, "config")) {
        sectionId = event.name.replace(`tab-${this.activeFlow.flowId}-`, "");
      } else {
        sectionId = event.name.replace(`tab-${this.activeFlow.flowId}-section-`, "");
      }
      this.currentTab = `section-${sectionId}`;
      this.$eventBus.$emit("setHeaderFilter", [this.activeFlow.flowId, sectionId]);
      if (this.formOptions.length === 0) {
        this.fetchForms()
      };
    },

    /**
     * @description On delete selected section confirmation
     * @return {void}
     */
    onDeleteSection(index) {
      this.$confirm(`Are you sure to delete the section?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "info",
      })
        .then(() => this.deleteSection(index))
        .catch(() => {});
    },

    /**
     * @description Delete a section
     * @return {void}
     */
    deleteSection(index) {
      this.activeFlow.sections.splice(index, 1);
    },
  },
};
</script>
<style scoped>
@media only screen and (max-width: 1280px) {
  .flow-section-title {
    flex-wrap: wrap;
  }
}
</style>
